/**
 * Dynamic import paths ต้องตรงกับ App.tsx (lazy routes) เพื่อใช้ chunk เดียวกับตอนนำทางจริง
 */
export function prefetchDashboardRoutes(): void {
  void import("@/pages/XianPage");
  void import("@/pages/XianVersusPage");
  void import("@/pages/PlayersPage");
  void import("@/pages/PlayerDetailPage");
  void import("@/pages/GamesPage");
  void import("@/pages/DomainAnalyticsPage");
  void import("@/pages/MarketingPage");
  void import("@/pages/SyncPage");
  void import("@/pages/SettingsPage");
}
